<template>
    <div>
        <b-button type="button" variant="outline-info" class="mb-3 mb-xs mr-xs">
            <label for="fileuploadexcel" style="cursor: pointer;">
                Upload users excel file
            </label>
        </b-button>

        <div class="form-group row">
            <div class="col-md-5">
                <input
                    style="display:none"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" @change="onChangeInputImage"
                    id="fileuploadexcel"
                    type="file" name="file" class="display-none"
                />
            </div>
        </div>
<!--        <div class="mb-3">-->
<!--            <label for="exampleFormControlInput1" class="form-label">Search users</label>-->
<!--            <input id="exampleFormControlInput1" type="text" @input="onChange" v-model="search"-->
<!--                   @keyup.down="onArrowDown" @keyup.up="onArrowUp" @keyup.enter="onEnter"-->
<!--                   class="form-control"/>-->
<!--        </div>-->

            <div class="form-group mt-4">
                <label for="notificationUsers">Select users</label>
                <v-select :clearable="false"
                          class="w-100"
                          id="notificationUsers"
                          :options="availableUsers"
                          @input="addUser">
                </v-select>



            </div>

<!--        <ul id="autocomplete-results" v-show="isOpen" class="list-group">-->
<!--            <li class="loading" v-if="isLoading">-->
<!--                Loading results...-->
<!--            </li>-->
<!--            <li v-else v-for="(user, i) in results" :key="i" @click="addUser(user)" class="list-group-item"-->
<!--                :class="{ 'is-active': i === arrowCounter }" style="">-->
<!--                {{ user.firstName }} {{ user.lastName }} {{ user.email }}-->
<!--            </li>-->
<!--        </ul>-->
        <Widget title="Users in group">
            <v-client-table :data="selectedUsers" :columns="columnsDatatable" :options="optionsDatatable">
                <div slot="Last logged in" slot-scope="props">
                    {{ formatDate(props.row.lastLoggedIn) }}
                </div>
                <div slot="roles" slot-scope="props">
                    <span v-for="(authority, i) in props.row.userAuthorities"
                          class="flex inline" :key="i">
                        <b-badge class="mr-1" variant="info" pill>{{ authority.role }}</b-badge>
                    </span>

                </div>
                <div slot="delete" slot-scope="props">
                    <span class="mx-auto">
                            <span class="glyphicon glyphicon-trash icon-button p-1"
                                  @click="removeUser(props.row)"/>
                        </span>
                </div>
            </v-client-table>
        </Widget>

    </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';
import Widget from '../Widget/Widget';
import Loader from '../Loader/Loader';
import vSelect from "vue-select";
import moment from 'moment';
import Vue from "vue";
import readXlsxFile from 'read-excel-file'
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker/src";
import datetime from "vuejs-datetimepicker";

export default {
    name: "UserSelector",
    components: { DatePicker, Loader, vSelect, VueTimepicker, datetime },
    props: {
        items: {
            type: Array,
            required: false,
            default: () => []
        },
        isAsync: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            isOpen: false,
            results: [],
            selectedUsers: [],
            availableUsers: [],
            search: "",
            isLoading: false,
            arrowCounter: 0,
            columnsDatatable: ['firstName', 'lastName', 'email', 'jobTitle', 'department', 'Last logged in', 'roles', 'delete'],
            optionsDatatable: {
                perPage: 10,
                pagination: {chunk: 10, dropdown: false},
                texts: {filter: '', count: '', limit: ''},
                columnsClasses: {id: 'width-100'},
                skin: 'table table-striped',
                sortIcon: {
                    base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
                },
                sortable: []
            }
        };
    },
    computed: {
        ...mapState("auth", ["currentUser"]),
        ...mapState("users", ["users", "isReceiving", "isDeleting", "idToDelete"]),
        ...mapState("countries", ["selectedCountry"]),
    },
    watch: {
        items(val) {
            // actually compare them
            this.onItemsChanged(val);
        },
        selectedCountry(val, oldVal) {
            if (oldVal == undefined || oldVal == null || oldVal.id != val.id)
                this.getUsersByTenantRequest(val.id);
        },
        users(val) {
            this.onItemsChanged(this.items);
            this.availableUsers = val.map(x => Object.assign ({} , x, {label: `${x.firstName} ${x.lastName} ${x.email}`}))
        }
    },
    methods: {
        ...mapActions("auth", ["fetchCurrentUser"]),
        ...mapActions("users", ["getUsersByTenantRequest", "selectUsers"]),
        async onChangeInputImage(e) {
            try {
                let xlsxfile = e.target.files ? e.target.files[0] : null;
                if(xlsxfile == null) {
                    return;
                }
                let rows = await readXlsxFile(xlsxfile);
                let emails = rows.map(element => element[0]);
                this.selectedUsers = [];
                for(const email of emails) {
                    let index = this.users.findIndex(x=>x.email == email);
                    if(index >= 0) {
                        this.addUser(this.users[index]);
                    }
                }
                e.target.value = null;
                console.log(emails);
            }
            catch (error) {
                this.$toasted.error("Could not process excel file")
            }
        },

        onChange() {
            // Let's warn the parent that a change was made
            this.$emit("input", this.search);

            // Is the data given by an outside ajax request?
            if (this.isAsync) {
                this.isLoading = true;
            } else {
                // Let's search our flat array
                this.filterResults();
                this.isOpen = true;
            }
        },

        onChangeNew(value,loading) {
            // Let's warn the parent that a change was made
            // this.$emit("input", this.search);
            // debugger;
            loading(true)
            this.search = value;
            // Is the data given by an outside ajax request?

                // Let's search our flat array
            this.filterResults();
            loading(false)

        },

        filterResults() {
            // first uncapitalize all the things
            this.results = this.users.filter(item => {
                return item.firstName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                    item.lastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                    item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
        formatDate(date) {
            return date ? moment.unix(date['seconds']).format('MMMM Do YYYY, h:mm:ss a') : '-'
        },
        addUser(result) {
            if (this.selectedUsers.findIndex(p => p.id == result.id) == -1)
                this.selectedUsers.push(result);
            this.selectUsers(this.selectedUsers);
            this.isOpen = false;
        },
        removeUser(result) {
            var index = this.selectedUsers.findIndex(p => p.id == result.id);
            if (index < 0)
                return;
            this.selectedUsers.splice(index, 1);
            this.selectUsers(this.selectedUsers);
            this.isOpen = false;
        },
        onArrowDown(evt) {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            this.search = this.results[this.arrowCounter];
            this.isOpen = false;
            this.arrowCounter = -1;
        },
        handleClickOutside(evt) {
            if (!this.$el.contains(evt.target)) {
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        },
        onItemsChanged(val) {
            if (val == undefined)
                this.selectedUsers = [];
            var newItems = this.users.filter(item => val.indexOf(item.id) >= 0);
            this.selectedUsers = newItems;
            this.selectUsers(newItems);

        }
    },
    async mounted() {
        document.addEventListener("click", this.handleClickOutside);
        if (this.currentUser == undefined || this.currentUser.id == null) {
            await this.fetchCurrentUser();
        }
        this.onItemsChanged(this.items);
    },
    destroyed() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};

</script>

<style scoped>
.autocomplete {
    position: relative;
    width: 400px;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    overflow: auto;
    width: 100%;
    position: absolute;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
}
</style>
